var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wash-and-care"},[_c('p',{staticClass:"text-gray mb-4"},[_vm._v(" "+_vm._s(_vm.productDetail.lavado.toLowerCase().replace(/^\w/, d => d.toUpperCase()))+" ")]),_c('div',{staticClass:"w-100",domProps:{"innerHTML":_vm._s(_vm.productDetail.lavado_cuidado)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }